<template>
  <p class="mb-3 cueLink" :class="styleClass(selected)" @click="$emit('ki-cue-toggle',cue.id)">
    <v-icon small class="cueIcon">{{icon(selected)}}</v-icon> {{cue.text}}
  </p>
</template>

<script>
export default {
  name: 'AssessmentCueSelector',
  props: ['cue', 'selected'],
  /*watch: {
    selected: {
      deep: true,
      handler() {
        console.log('WATCH IT');
      }
    }
  },*/
  methods: {
    icon(selected) {
      console.log('check selected', selected)
      return selected === true ? 'mdi-check-circle-outline' : 'mdi-circle-outline';
    },
    styleClass(selected) {
      return selected === true ? 'cueLinkSelected' : '';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/ci.scss';

  .cueLink:hover{
    color: $primary;
    cursor: pointer;
  }

  .cueLinkSelected{
    color: $primary;
  }

  .cueLinkSelected:hover{
    color: black;
  }

  .cueIcon{
    color:inherit;
  }
</style>
